<template>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">
        <div style="text-align: center; padding: 20px;">
            <h1>Well done, you finished the case!</h1>
            <div style="font-size: 400%">
                +<i class="fas fa-star" style="color: gold"></i> <countTo :startVal='0' :endVal='pointsDisplayed' :duration='pointsDuration'></countTo>
            </div>
            <hr>
            <transition-group name="point-tally" style="font-size: 200%; font-weight: bold;">
                <div v-for="(pointEntry, entryIndex) in pointTally" :key="entryIndex" style="margin-bottom: 15px;">
                    {{pointEntry}}
                </div>
            </transition-group>
            <div style="margin-top: 20px; font-size: 140%" v-show="pointsDisplayed == pointsEarned">
                Returning to case list...
            </div>
        </div>
    </md-dialog>
</template>

<script>
    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    import countTo from 'vue-count-to';
    export default {
        props: {
            pointsEarned: Number,
        },
        watch: {
            pointsEarned() {
                if(this.pointsEarned > 0) {
                    // Show reward dialog
                    this.showDialog = true;
                    delay(250).then(() => {
                        // Add 200 pts for completing
                        this.pointsDisplayed = 200
                        this.pointTally.push("+200 - Case completed! ")
                        return delay(this.pointsDuration + 500)
                    })
                    .then(() => {
                        if (this.pointsEarned == 250) {
                            this.pointsDisplayed = 250
                            this.pointTally.push("+50 - Case reviewed!")
                            return delay(this.pointsDuration)
                        }
                    }).then(() => {
                        return delay(1500);
                    }).then(() => {
                        let redirectURL = "/cases"
                        if(this.$route.query.classroom && this.$route.query.assignment){
                            let classroomID = this.$route.query.classroom
                            let assignmentID = this.$route.query.assignment
                            redirectURL = "/classroom/" + classroomID + "?viewer=true&assignment=" + assignmentID
                        }
                        window.location.href = redirectURL; // Changed to refresh of page to update learner score in sidebar
                    })                    
                }
            }
        },
        data: () => ({
            pointsDisplayed: 0,
            pointsDuration: 1500,
            pointTally: [],
            showDialog: false,
        }),
        components: {
            countTo,
        }
    }
</script>

<style scoped>
    .point-tally-enter-active, .point-tally-leave-active {
        transition: all 1s;
    }
    .point-tally-enter, .point-tally-leave-to /* .list-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: translateY(30px);
    }
</style>